import { render } from "./AdicionarCarrinho.vue?vue&type=template&id=3ebc6477&scoped=true"
import script from "./AdicionarCarrinho.vue?vue&type=script&lang=js"
export * from "./AdicionarCarrinho.vue?vue&type=script&lang=js"

import "./AdicionarCarrinho.vue?vue&type=style&index=0&id=3ebc6477&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebc6477"]])

export default __exports__